import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutes } from './home.routing';
import { HomeComponent } from './pages/home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NextRacesComponent } from './pages/next-races/next-races.component';
import { CarouselModule } from 'primeng/carousel';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    HomeComponent,
    NextRacesComponent
  ],
  imports: [
    CommonModule,
    HomeRoutes,
    SharedModule,
    NgbModule,
    FormsModule,
    NgbModule,
    CarouselModule,
    TranslateModule
  ],
})
export class HomeModule { }
